var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6098",
    "data-name": "Grupo 6098",
    transform: "translate(-384 -491)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2306",
    "data-name": "Ret\\xE2ngulo 2306",
    width: 88,
    height: 88,
    rx: 20,
    transform: "translate(384 491)",
    fill: "#c2caf2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete_50dp_5F6368",
    transform: "translate(401 508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8560",
    "data-name": "Caminho 8560",
    d: "M0,0H55V55H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8561",
    "data-name": "Caminho 8561",
    d: "M7.292,39.667a4.6,4.6,0,0,0,4.583,4.583H30.208a4.6,4.6,0,0,0,4.583-4.583v-27.5H7.292ZM37.083,5.292H29.063L26.771,3H15.313L13.021,5.292H5V9.875H37.083Z",
    transform: "translate(6.458 3.875)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.3d353bf0.svg";
export { ForwardRef as ReactComponent };